import TextInput from "../TextInput/TextInput";

const StaticLoginForm = ({staticLogin, onChange}) => {
    const changeStaticLogin = (key, value) => {
        const newStaticLogin = {...staticLogin, [key]: value};
        onChange(newStaticLogin);
    }

    return (
        <div className={"row"}>

                <div className="col-md-6">
                    <TextInput id={"username"} name={"username"} autoComplete='new-username' autoCorrect="off" label={"نام کاربری"}
                               value={staticLogin.username} onChange={(value) => {
                        changeStaticLogin("username", value);
                    }}/>
                </div>
                <div className="col-md-6">
                    <TextInput id={"password"} name={"password"} autoComplete='new-password' type={"password"} classname={"ltr"}
                               label={"رمز عبور"} value={staticLogin.password} onChange={(value) => {
                        changeStaticLogin("password", value);
                    }}/>
                </div>

        </div>
);


}

export default StaticLoginForm;